An HTTP request to a `WebhookSubscription`.

HTTP requests are associated with one or more `WebhookAttempt`s representing each `Event` in the request body.
